export default __webpack_public_path__ + "images/f3c29615d3a3a0528be0e56cf288c1a6-indie.webp";